import { Link } from 'react-router-dom';
import { toast } from 'react-toastify';
import CopyIcon from '../../../assets/Icon/CopyIcon';

export default function TransactionLink({
  transactionNo,
}: {
  transactionNo: string;
}) {
  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <Link
        to={`${process.env.REACT_APP_TRANSACTION_ID}/transactions?transactionId=${transactionNo}&network=${process.env.REACT_APP_NETWORK}`}
        target="_blank"
        className="px-0 outline-0 "
        style={{ textDecoration: 'none', color: '#1d77ff' }}
      >
        {transactionNo
          ? `${transactionNo?.slice(0, 5)}...${transactionNo?.slice(-3)}`
          : '-'}
      </Link>
      <a
        style={{
          marginLeft: '5px',
          border: 'none',
          backgroundColor: 'transparent',
          cursor: 'pointer',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
        onClick={() => {
          navigator.clipboard.writeText(transactionNo);
          toast.success('Copied!');
        }}
      >
        <CopyIcon />
      </a>
    </div>
  );
}
